<template>
<div class="chapter">
<div class="inner_page">
<p><a id="cop"></a></p><a id="cop">
<div class="crt">Copyright © 2009 by Galina Krasskova and Raven Kaldera</div>
<div class="crt">All rights reserved under the Pan-American and International Copyright Conventions. This book may not be reproduced, in whole or in part, in any form or by any means electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system now known or hereafter invented, without written permission from the publisher, The Career Press.</div>
<div class="crt"><b>NORTHERN TRADITION FOR THE SOLITARY PRACTITIONER</b>  EDITED BY KIRSTEN DALLEY TYPESET BY EILEEN MUNSON Cover design by Leeza Henandez / Conker Tree Printed in the U.S.A. by Book-mart Press</div>
<div class="crt">To order this title, please call toll-free 1-800-CAREER-1 (NJ and Canada: 201-848-0310) to order using VISA or MasterCard, or for further information on books from Career Press.</div>
<div class="acrt1"><div class="centerAligned"><img alt="002" class="imgepub" src="bano_9781601639547_oeb_002_r1.gif"/></div>
</div>
</a><div class="crt"><a id="cop">The Career Press, Inc., 3 Tice Road, PO Box 687, Franklin Lakes, NJ 07417  <b></b></a><b><a href="http://www.careerpress.com" target="_blank">www.careerpress.com</a> <a href="http://www.newpagebooks.com" target="_blank">www.newpagebooks.com</a></b></div>
<div> <br/><br/></div><div class="crt">Library of Congress Cataloging-in-Publication Data Krasskova, Galina, 1972-</div>
<div class="crt">Northern tradition for the solitary practitioner : a book of prayer, devotional practice, and the nine worlds of the spirit / by Galina Krasskova and Raven Kaldera. p. cm.</div>
<div class="crt">Includes bibliographical references and index.</div>
<div class="crt">ISBN 978-1-60163-034-6</div><div class="crt">eISBN : 978-1-601-63954-7</div>
<div class="crt">1. Germanic peoples—Religion. 2. Spiritual life. I. Kaldera, Raven. II. Title.</div>
<div class="crt">BL860.K734 2009 2005 293--dc22</div>
<div class="crt">2008041692</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bano_9781601639547_oeb_cop_r1.vue?6a776e12